import AccettazionePazienteImpegnativePage from "./pages/AccettazionePazienteImpegnativePage.vue";
import AccettazionePazienteAppuntamentiPage from "./pages/AccettazionePazienteAppuntamentiPage.vue"
export default { AccettazionePazienteImpegnativePage, AccettazionePazienteAppuntamentiPage }